const artists = {
    "r&b": [
      {
        name: "the weeknd",
        songs: "Heartless, The Hills, Starboy",
        url:
          "https://static.billboard.com/files/2020/06/the-weeknd-2020-cr-Pari-Dukovic-billboard-1548-1593528016-768x433.jpg"
      },
      {
        name: "Chris Brown",
        songs: "Party, Grass ain't greener, Qustions",
        url:
          "https://e-cdns-images.dzcdn.net/images/artist/ed15b84067164aa25701fdd30cc34d33/500x500.jpg"
      },
      {
        name: "Post Malone",
        songs: "Fall Apart, White Iverson, Hollywod Bleeding",
        url: "https://i1.sndcdn.com/artworks-000504299538-oofu7w-t500x500.jpg"
      },
      {
        name: "Khalid",
        songs: "Lovely, Young drunk and broke, Better",
        url: "https://i1.sndcdn.com/artworks-000383618736-k79v5d-t500x500.jpg"
      },
      {
        name: "Kendrick Lamar",
        songs: "Humble, loyalty, All the stars, DNA, Sidewalks",
        url: "https://i1.sndcdn.com/avatars-000307738538-06q3jf-t500x500.jpg"
      }
    ],
  
    rappers: [
      {
        name: "Lil Uzi Vert",
        songs: "XO tour llif3, Baby Pluto, Patek",
        url: "https://m.media-amazon.com/images/I/51Yuxj1hKvL.jpg"
      },
      {
        name: "Jack Harlow",
        songs: "What's poppin, Tyler Herro, Hot Boy Bling",
        url:
          "https://townsquare.media/site/812/files/2020/08/jack-harlow-abcs.jpg?w=1200"
      },
      {
        name: "Travis Scott",
        songs: "Highest In the room, Butterfly Effect, Goosebumps",
        url:
          "https://echoingwalls.com/blog/wp-content/uploads/2018/09/travis-scott-pays-tribute-to-late-mac-miller-on-stage.jpg"
      },
      {
        name: "Future",
        songs: "Mask off, That's it, Low Life",
        url:
          "https://cdns-images.dzcdn.net/images/artist/b6cbe1b72cc372f17d6814f9cf5c7005/500x500.jpg"
      },
      {
        name: "Kid Laroi",
        songs: "Addison Rae, Tell Me Why, So Done",
        url: "https://f4.bcbits.com/img/0020989692_10.jpg"
      },
      {
        name: "juice Wrld",
        songs: "Lucid Dreams, Armed and Dangerous, Robbery",
        url: "https://image.mymixtapez.com/artists/30477/profile/medium"
      },
      {
        name: "King von",
        songs: "Crazy Story, Crazy Stroy 2.0, Glessh Place",
        url: "https://i1.sndcdn.com/artworks-000457004700-uzfux5-t500x500.jpg"
      }
    ],
    pop: [
      {
        name: "Justin Bieber",
        songs: "Baby, Yummy, Intentions",
        url:
          "https://assets.teenvogue.com/photos/5f58d4e14111b77a6cb7f808/4:3/w_3015,h_2261,c_limit/GettyImages-1228408822.jpg"
      },
      {
        name: "Shawn Mendes",
        songs: "Stiches, Senorita, Treat you better",
        url:
          "https://thumbor.forbes.com/thumbor/fit-in/416x416/filters%3Aformat%28jpg%29/https%3A%2F%2Fspecials-images.forbesimg.com%2Fimageserve%2F5ed56f207fe4060006bbce9a%2F0x0.jpg%3Fbackground%3D000000%26cropX1%3D0%26cropX2%3D1080%26cropY1%3D0%26cropY2%3D1080"
      },
      {
        name: "Ed Sheeran",
        songs: "Shape of You, perfect, Galway Girl",
        url:
          "https://c4.wallpaperflare.com/wallpaper/855/883/777/4k-grammy-2018-ed-sheeran-photo-wallpaper-preview.jpg"
      }
    ],
    CountryMusic: [
      {
        name: "Lil Nas X",
        songs: "Old Town Road, Old Town Road(Remix), Panini",
        url:
          "https://e-cdns-images.dzcdn.net/images/artist/e645a215208b825df07277d80299758d/500x500.jpg"
      },
      {
        name: "Billy Ray cyrus",
        songs: "Butterfly Fly Away, Ready Set Don't go, Old Town Road(remix)",
        url:
          "https://i.pinimg.com/564x/41/96/69/419669a86ed03b912360a51d6aed26c3.jpg"
      }
    ]
  };
  
  export default artists;
  